export default "__VITE_PUBLIC_ASSET__01f1632e__"